import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidenavService {
  state : BehaviorSubject<boolean> = new BehaviorSubject(false)
}
